module.exports = __webpack_public_path__ + "static/media/python_logo.b37c6438.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tech_logos/python_logo.png
// module id = 84
// module chunks = 0